<template>
    <div class="modal fade" id="downloadPreviewModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-body text-center" v-if="showingPreview">
                    <img :src="showingPreview" class="img-fluid">
                </div>
                <div class="modal-footer">
                    <a :href="downloadUrl" v-if="downloadUrl" target="_blank" class="btn btn-secondary"><i class="fa fa-download"></i> {{ __('Download') }}</a>
                    <button type="button" class="btn btn-primary text-white"  data-bs-dismiss="modal">{{ __('Close') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import {getCurrentInstance, onMounted} from "vue";
import {ref} from "vue";

const showingPreview = ref(null);
const downloadUrl = ref(null);

let proxy = null;
onMounted(() => {
    proxy = getCurrentInstance().proxy;

    proxy.eventHub.$on('previewDownload', (previewImage, newDownloadUrl) => {
        showingPreview.value = previewImage;
        downloadUrl.value = newDownloadUrl;

        jQuery('#downloadPreviewModal').modal('show');
    });
});
</script>
